import { Button } from '@fukuri-admins/ui/common/Button';
import { PlusIcon } from '@fukuri-admins/ui/common/Icons';
import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.scss';

type Props = {
  isDragging: boolean;
  /** input[accept] に渡す文字列（例: ".jpg,.png,.pdf"） */
  acceptAttr: string;
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
  onFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  /** アップロード中フラグ。trueのとき、スピナーと進行中テキストを表示する */
  isUploading?: boolean;
  /** disabled フラグ。trueのとき、ドラッグ・クリックを無効化する */
  disabled?: boolean;
  /** エラーフラグ。trueのとき、エラー用ボーダー・背景色を適用する */
  isError?: boolean;
};

export const DropZone: React.FC<Props> = ({
  isDragging,
  acceptAttr,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileInputChange,
  fileInputRef,
  isUploading = false,
  disabled = false,
  isError = false,
}) => (
  <section
    aria-label='ファイルのドロップ領域'
    // tabIndex により キーボードフォーカスを有効化し :focus-visible スタイルを適用する
    tabIndex={disabled || isUploading ? -1 : 0}
    className={clsx(
      styles.dropZone,
      isDragging && !disabled && !isUploading && styles.dragging,
      isUploading && styles.uploading,
      disabled && styles.disabled,
      isError && !disabled && styles.error
    )}
    onDragOver={disabled || isUploading ? undefined : onDragOver}
    onDragLeave={disabled || isUploading ? undefined : onDragLeave}
    onDrop={disabled || isUploading ? undefined : onDrop}
  >
    {isUploading ? (
      // Loading 状態：スピナー + 進行中テキスト
      <div className={styles.loadingContent}>
        <span className={styles.spinner} aria-hidden='true' />
        <p className={styles.loadingText}>ファイルをアップロードしています...</p>
      </div>
    ) : (
      <>
        <div className={styles.textGroup}>
          <p className={styles.label}>ファイルをここにドラッグアンドドロップ</p>
          <p className={styles.or}>または</p>
        </div>
        <Button
          variant='outline'
          size='sm'
          icon={<PlusIcon size='xs' />}
          iconPosition='left'
          disabled={disabled}
          onClick={disabled ? undefined : () => fileInputRef.current?.click()}
        >
          ファイル選択
        </Button>
        {/* ファイル選択ダイアログ用の非表示input */}
        <input
          ref={fileInputRef}
          type='file'
          accept={acceptAttr}
          className={styles.hiddenInput}
          onChange={onFileInputChange}
          disabled={disabled}
        />
      </>
    )}
  </section>
);
